import type { SxProps, Theme } from '@mui/material/styles';

type ResponsiveDataGridOptions = {
	isMobile: boolean;
	rowHeight?: number;
	sx?: SxProps<Theme>;
};

/** Keeps the compact mobile grid baseline consistent across list views. */
export function getResponsiveDataGridProps({ isMobile, rowHeight = 48, sx }: ResponsiveDataGridOptions) {
	const customSx = Array.isArray(sx) ? sx : [sx];

	return {
		density: isMobile ? ('compact' as const) : ('standard' as const),
		rowHeight: isMobile ? rowHeight : undefined,
		sx: [{ border: 0, minWidth: 0 }, isMobile && { '& .MuiDataGrid-cell': { minWidth: 0 } }, ...customSx] as SxProps<Theme>,
	};
}
